<template>
  <div 
    class="masonry-wall flex items-start w-full gap-4"
    ref="masonryContainer"
  >
    <div 
      v-for="(column, columnIndex) in columnItems" 
      :key="columnIndex"
      class="masonry-column flex flex-col flex-1 basis-0 min-w-0 gap-4"
    >
      <div 
        v-for="(item, itemIndex) in column" 
        :key="item.id || itemIndex"
        class="masonry-item w-full"
      >
        <slot :item="item" :index="item.originalIndex" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, nextTick } from 'vue';

const props = defineProps({
  items: {
    type: Array,
    default: () => []
  },
  columns: {
    type: Number,
    default: 2
  },

});

const masonryContainer = ref(null);

// Distribute items across columns from left to right, top to bottom
const columnItems = computed(() => {
  if (!props.items || props.items.length === 0) {
    return Array(props.columns).fill([]);
  }

  const columns = Array(props.columns).fill(null).map(() => []);
  
  // Add original index to items for tracking
  const itemsWithIndex = props.items.map((item, index) => ({
    ...item,
    originalIndex: index
  }));

  // Distribute items sequentially across columns
  itemsWithIndex.forEach((item, index) => {
    const columnIndex = index % props.columns;
    columns[columnIndex].push(item);
  });

  return columns;
});

// Watch for changes in items to trigger re-layout if needed
watch(() => props.items, () => {
  nextTick(() => {
    // Container will automatically adjust due to reactive columnItems
  });
}, { deep: true });
</script>
